module.exports = __webpack_public_path__ + "img/success-icon.6b6d1b41.svg";